import { isNfcAvailable } from '../utils';
import { AppMode } from './app-mode';
import {
    defaultAppMode,
    defaultInputMode,
    defaultScanFlowRegistrationSubmitIntervalMs,
} from './app-settings';
import { InputMode } from './input-mode';
import { AppModeModel, DeviceProfileModel, InputModeModel } from './server';

export const defaultDeviceProfile: DeviceProfile = {
    name: '',
    description: '',
    appMode: defaultAppMode,
    inputMode: defaultInputMode,
    submissionIntervalSeconds: defaultScanFlowRegistrationSubmitIntervalMs,
};

export interface DeviceProfile {
    name?: string;
    description?: string;
    appMode: AppMode;
    inputMode: InputMode;
    submissionIntervalSeconds: number;
}

export function mapModelToDeviceProfile(model: DeviceProfileModel | null): DeviceProfile {
    if (!model?.name) return defaultDeviceProfile;

    const inputModeDeviceProfile = getInputModeFromModel(model.inputMode);
    let inputMode = inputModeDeviceProfile;
    // Only Android devices support inputMode "nfc"
    // When device doesn't support nfc, the fallback goes to "manual" to prevent work disruptions
    if (inputModeDeviceProfile === 'nfc') {
        inputMode = isNfcAvailable() ? inputModeDeviceProfile : 'manual';
    }

    return {
        name: model?.name?.trim() || '',
        description: model?.description?.trim() || '',
        appMode: getAppModeFromModel(model.appMode) ?? defaultAppMode,
        inputMode: inputMode ?? defaultInputMode,
        submissionIntervalSeconds: model.submissionIntervalSeconds,
    };
}

function getAppModeFromModel(appMode: AppModeModel): AppMode {
    switch (appMode) {
        case AppModeModel.MultiUser:
            return 'multi-user';
        case AppModeModel.Personal:
            return 'personal';
    }
}

function getInputModeFromModel(inputMode: InputModeModel): InputMode {
    switch (inputMode) {
        case InputModeModel.Manual:
            return 'manual';
        case InputModeModel.QrCode:
            return 'barcode';
        case InputModeModel.NfcTag:
            return 'nfc';
    }
}
